const dateFormat = function(source) {
  let myDate;
  let separate = "-";
  let minute = "";
  let time = null;
  let formatTime = "";
  if (source === void 0) {
    source = new Date();
  }
  if (source) {
    if (source.split) {
      source = source.replace(/\-/g, "/");
    } else if (isNaN(parseInt(source))) {
      source = source.toString().replace(/\-/g, "/");
    } else {
      source = new Date(source);
    }

    if (new Date(source) && new Date(source).getDate) {
      myDate = new Date(source);
      minute =
        (myDate.getHours() < 10 ? " 0" : " ") +
        myDate.getHours() +
        ":" +
        (myDate.getMinutes() < 10 ? "0" : "") +
        myDate.getMinutes() +
        ":" +
        (myDate.getSeconds() < 10 ? "0" : "") +
        myDate.getSeconds();
      let year = myDate.getFullYear();
      let month =
        myDate.getMonth() + 1 < 10
          ? "0" + (myDate.getMonth() + 1)
          : myDate.getMonth() + 1;
      let monthNum;
      if (!isNaN(month)) {
        monthNum = month;
      } else {
        monthNum = parseInt(month);
      }

      formatTime =
        year +
        separate +
        month +
        separate +
        (myDate.getDate() < 10 ? "0" : "") +
        myDate.getDate() +
        minute;
    } else {
      formatTime = source.slice(0, 16);
    }
  }
  //console.log(formatTime, "starttime")
  time = new Date(formatTime).getTime();
  return time;
};
const Countdown = function(tagTime, nowTime) {
  this.tagTime = tagTime;
  this.showTime = "";
  this.time = null;
  this.nowTime = nowTime;
};
Countdown.prototype.goAfter = function(callBack) {
  if (!this.tagTime) return;
  let showTime = "";
  clearInterval(this.time);
  this.time = setInterval(() => {
    let endItem = new Date(dateFormat(this.tagTime)).getTime(); // 获取列表传的截止时间
    let nowItem = new Date(dateFormat(this.nowTime)).getTime(); // 获取当前时间
    let rightTime = nowItem - endItem; // 截止时间减去当前时间

    // console.log(rightTime, 'rightTime', endItem, nowItem)
    if (rightTime >= 0) {
      // 判\断剩余倒计时时间如果大于0就执行倒计时否则就结束
      let dd = Math.floor(rightTime / 1000 / 60 / 60 / 24);
      let hh = Math.floor((rightTime / 1000 / 60 / 60) % 24);
      let mm = Math.floor((rightTime / 1000 / 60) % 60);
      let ss = Math.floor((rightTime / 1000) % 60);
      showTime = dd + "天" + hh + "小时" + mm + "分" + ss + "秒";
      this.showTime = showTime;
      this.nowTime = nowItem - 1000; // todo: 原来是向上加1秒
      callBack(showTime, this.time);
      // console.log(this.showTime, 'this.showTime')
      // time = setTimeout(countdown(endtime), 1000)
    } else {
      showTime = "";
      callBack("", "");
      clearInterval(this.time);
    }
  }, 1000);
};
Countdown.prototype.goBefor = function(callBack) {
  if (!this.tagTime) return;
  let showTime = "";
  clearInterval(this.time);
  this.time = setInterval(() => {
    let endItem = new Date(dateFormat(this.tagTime)).getTime(); // 获取列表传的截止时间
    let nowItem = new Date(dateFormat(this.nowTime)).getTime(); // 获取当前时间
    let rightTime = endItem - nowItem; // 截止时间减去当前时间

    // console.log(rightTime, 'rightTime', endItem, nowItem)
    if (rightTime >= 0) {
      // 判\断剩余倒计时时间如果大于0就执行倒计时否则就结束
      let dd = Math.floor(rightTime / 1000 / 60 / 60 / 24);
      let hh = Math.floor((rightTime / 1000 / 60 / 60) % 24);
      let mm = Math.floor((rightTime / 1000 / 60) % 60);
      let ss = Math.floor((rightTime / 1000) % 60);
      showTime = dd + "天" + hh + "小时" + mm + "分" + ss + "秒";
      this.showTime = showTime;
      this.nowTime = nowItem + 1000;
      callBack(showTime, this.time);
      // console.log(this.showTime, 'this.showTime')
      // time = setTimeout(countdown(endtime), 1000)
    } else {
      showTime = "";
      callBack("", "");
      clearInterval(this.time);
    }
  }, 1000);
};
// 倒计时
//  var time = new Countdown('2020-03-16 09:00:00','2020-03-16 08:59:50')
//  var callBack = (val, timer) => {
//    console.log(val)
//  }
//  time.goBefor(callBack)
// 正计时
//  var time = new Countdown('2020-03-16 09:00:00','2020-03-16 09:00:00')
//  var callBack = (val, timer) => {
//    console.log(val)
//  }
//  time.goAfter(callBack)
export default Countdown;

// 售后留心消息 - 时间
export function getHMS(date) {
  let time = new Date(date).getTime() - new Date().getTime();
  let timeOut = false;
  // console.log("time---", time);
  if (time < 1000) {
    return { timeOut: true };
  }
  const days = Math.floor(time / 1000 / 60 / 60 / 24);
  const hours = Math.floor((time / 1000 / 60 / 60) % 24) + days * 24;
  const minutes = Math.floor((time / 1000 / 60) % 60);
  const seconds = Math.floor((time / 1000) % 60);
  return {
    timeOut,
    hours: hours < 10 ? `0${hours}` : hours,
    minutes: minutes < 10 ? `0${minutes}` : minutes,
    seconds: seconds < 10 ? `0${seconds}` : seconds,
    countDownTime:
      (hours < 10 ? `0${hours}:` : `${hours}:`) +
      (minutes < 10 ? `0${minutes}:` : `${minutes}:`) +
      (seconds < 10 ? `0${seconds}` : `${seconds}`)
  };
}



// WEBPACK FOOTER //
// ./src/utils/time.js